import { db, auth } from "../util/firebase";

export default {

    // ********* \\
    // BASE DATA \\
    // ********* \\

    getItem (state) {
        return state.item;
    },

    getItems (state) {
        return state.items;
    },

    getFilteredConfessions (state) {
        // return state.filtering ? state.filteredConfessions : state.confessions;
    },
    
    getUsers (state) {
        return state.users;
    },
    

    // ************** \\
    // USER INTERFACE \\
    // ************** \\

    getLoading (state) {
        return state.loading;
    },
    
    getContentLoading (state) {
        return state.contentLoading;
    },
    
    getHasExtension (state) {
        return state.hasExtension;
    },

    getPendingTransaction (state) {
        return state.pendingTransaction;
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js